import tw, { styled } from 'twin.macro';

export const MainChoiceWrapper = styled.div`
  ${tw`mb-3 w-full h-auto`}
  &.inline {
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-start;
    & img {
      margin-left: 0 !important;
    }

    > div {
      min-width: 200px;
    }
  }
`;

export const RadioInput = styled.input`
  ${tw`cursor-pointer opacity-50 w-4.5 h-4.5`};
  accent-color: #1a8caf;

  &:checked {
    ${tw`opacity-100`};
  }
`;

export const RadioWrapper = styled.div`
  ${tw`py-0.5 my-3 relative`};
`;

export const RadioLabel = styled.label`
  ${tw`ml-2 mr-2 pl-7 block outline-none text-base opacity-70`}
  font-family: 'Circular Std' !important;
  color: #777;
  user-select: none;
  line-height: 15px;
  margin-top: -22px;

  ${({ notInBuilder }) =>
    notInBuilder &&
    `
    font-size: var(--formFontSize);
    color: var(--formBodyLabelColor, var(--formTextColor));
    text-transform: var(--formLabelTransform);
    font-family: var(--formFontType) !important;
  `}

  &.rtl {
    ${tw`pr-7 pl-0`};
  }
`;
